import { COLLECTION_GAPS, FIXED_INDENTS, LAYOUT } from 'vars/index'

export const GridLoadingByCardRowGaps = {
  DEFAULT: COLLECTION_GAPS.GRID_GAP_HORIZONTAL,
} as const
export type GridLoadingByCardRowGap =
  (typeof GridLoadingByCardRowGaps)[keyof typeof GridLoadingByCardRowGaps]

export const GridLoadingByCardColumnGaps = {
  DEFAULT: COLLECTION_GAPS.GRID_GAP_VERTICAL,
} as const
export type GridLoadingByCardColumnGap =
  (typeof GridLoadingByCardColumnGaps)[keyof typeof GridLoadingByCardColumnGaps]

export const GridLoadingByCardPaddings = {
  SIZE_10: [
    FIXED_INDENTS.INDENT_70,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_70,
  ],
}
export type GridLoadingByCardPadding =
  (typeof GridLoadingByCardPaddings)[keyof typeof GridLoadingByCardPaddings]

export const GridLoadingByCardTitleMargins = {
  SIZE_10: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    LAYOUT.VerticalGridTitlePaddings,
  ],
}
export type GridLoadingByCardTitleMargin =
  (typeof GridLoadingByCardTitleMargins)[keyof typeof GridLoadingByCardTitleMargins]
